import { obterControleFrotaAsync } from "../../services/controleFrotaService";

const atualizarControleFrotas = async ({ commit }) => {
    const controleFrotas = await obterControleFrotasAsync();
    commit('atualizarControleFrotas', controleFrotas);
}

const atualizarControleFrota = ({ commit }, controleFrota) => {
    commit('atualizarControleFrota', controleFrota);
}

export default {
    atualizarControleFrotas,
    atualizarControleFrota
}